import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ViewWebLibModule } from '@com-banistmo/view-web-lib-emp';
import { TranslateModule } from '@ngx-translate/core';

import { HeaderComponent } from './header/header.component';

@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ViewWebLibModule
  ],
  exports: [
    FormsModule,
    ViewWebLibModule,
    TranslateModule,
    HeaderComponent
  ]
})
export class SharedModule { }
